<template>
  <div>
    <div class="level">
      <div class="level-left">
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="status" title="Request status">
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="disapproved">Disapproved</option>
        </b-select>
      </div>
    </div>
    <table-pagination :tableData="timesheetForModification.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="timesheetForModification.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column field="refId" class="table-column-content-is-small" label="Ref #">
          {{item.row.refId}}
        </b-table-column>
        <b-table-column field="employeeIdNumber" class="table-column-content-is-small" label="Employee ID #">
          {{item.row.employeeIdNumber}}
        </b-table-column>
        <b-table-column field="employeeName" class="table-column-content-is-small" label="Name">
          {{item.row.employeeName}}
        </b-table-column>
        <b-table-column field="period" class="table-column-content-is-small" label="Period">
          {{item.row.period}}
        </b-table-column>
        <b-table-column field="note" class="table-column-content-is-small" label="Note">
          {{item.row.note}}
        </b-table-column>
        <b-table-column field="status" class="table-column-content-is-small" label="Status">
          <span v-show="item.row.status === 0">Pending</span>
          <span v-show="item.row.status === 1">Approved</span>
          <span v-show="item.row.status === 2">Disapproved</span>
        </b-table-column>
        <b-table-column field="" class="table-column-content-is-small" label="">
          <router-link :to="{name: 'View TimeSheet for Modification', params: {timesheetmodificationId: item.row.timeSheetForModificationId}}" class="button is-warning is-small">View</router-link>
          &nbsp;
          <button class="button is-danger is-small" @click="openDeleteModal(item.row.timeSheetForModificationId)">Delete</button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </table-pagination>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete timesheet for modification</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Are you sure do you want to delete this permanently?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonDelete" @click="deletePermanently">Yes</button>
          <button class="button is-small" @click="cancel">No</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import TablePagination from '../TablePagination.vue'
import { mapState, mapActions } from 'vuex'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      isEmpty: false,
      page: 1,
      perPage: 10,
      search: '',
      showDeleteModal: false,
      timesheetForModificationId: 0,
      buttonDelete: appButton.isLoadingDanger(false),
      status: 'all'
    }
  },
  mounted() {
    this.default()
  },
  computed: {
    ...mapState('timesheetformodification', {
      timesheetForModification: state => state.timesheetForModification,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  components: {
    tablePagination: TablePagination
  },
  methods: {
    ...mapActions('timesheetformodification', ['getPaginatedTimeSheets']),
    default() {
      this.showDeleteModal = false
      this.timesheetForModificationId = 0
      this.buttonDelete = appButton.isLoadingDanger(false)
      this.getPaginatedTimeSheets({
        page: this.page,
        pageSize: this.perPage,
        status: this.status,
        query: this.search
      })
    },
    openDeleteModal(id) {
      this.timesheetForModificationId = id
      this.showDeleteModal = true
    },
    deletePermanently() {
      if (this.timesheetForModificationId) {
        this.buttonDelete = appButton.isLoadingDanger(true)
        axios
          .delete(
            `api/timeSheetformodifications/${this.timesheetForModificationId}`
          )
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => appToast.danger(error))
          .then(() => {
            this.default()
          })
      }
    },
    refreshTable() {
      this.default()
    },
    cancel() {
      this.default()
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedTimeSheets({
        page: this.page,
        pageSize: val,
        status: this.status,
        query: this.search
      })
    },
    page(val) {
      this.getPaginatedTimeSheets({
        page: val,
        pageSize: this.perPage,
        status: this.status,
        query: this.search
      })
    },
    search(val) {
      this.getPaginatedTimeSheets({
        page: this.page,
        pageSize: this.perPage,
        status: this.status,
        query: val
      })
    },
    status() {
      this.getPaginatedTimeSheets({
        page: this.page,
        pageSize: this.perPage,
        status: this.status,
        query: this.search
      })
    }
  }
}
</script>

